import { useCallback } from 'react';
import { useLazyGetEmissorOrderQuery } from '../services/contractOrdersApi';
export function useEmissorOrder() {
    const [trigger, { isLoading }] = useLazyGetEmissorOrderQuery();
    const getOrder = useCallback((params) => trigger(params, false).unwrap(), [trigger]);
    return { getOrder, isLoading };
}
